const VideoCarousel = {
  parts: [
    'container',
    'mediaContainer',
    'mediaItem',
    'image',
    'video',
    'overlay',
    'contentWrapper',
    'heading',
    'tabsList',
    'mobileSwiper',
    'tab',
    'tabContent',
    'tabNumber',
    'tabTitle'
  ],
  baseStyle: {
    container: {
      position: 'relative',
      width: 'full',
      overflow: 'hidden',
    },
    mediaContainer: {
      position: 'relative',
      width: 'full',
      bg: 'black',
      aspectRatio: {base: '375/700', md: '72/43'},
    },
    mediaItem: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 'full',
      height: 'full',
    },
    image: {
      width: 'full',
      height: 'full',
      objectFit: 'cover',
    },
    video: {
      width: 'full',
      height: 'full',
      pointerEvents: 'none',
      iframe: {
        width: '100%',
        height: '100%',
      },
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 'full',
      height: 'full',
      background: 'linear-gradient(0deg,rgba(0, 0, 0, 1) 13.76%, rgba(0, 0, 0, 0) 47.29%, rgba(0, 0, 0, 1) 100%)',
      pointerEvents: 'none',
    },
    contentWrapper: {
      position: 'absolute',
      bottom: {base: 12.5, lg: 20},
      left: 0,
      right: 0,
      maxWidth: '1440px',
      mx: 'auto',
      px: {base: 11.75, lg: 20},
      overflow: 'hidden',
    },
    heading: {
      color: 'brandColors.primaryBG',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: '28px', lg: '40px'},
      fontWeight: 'medium',
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', lg: '-0.4px'},
      mb: 0,
      position: 'absolute',
      top: {base: 11.25, lg: '50%'},
      left: {base: 5, lg: 0},
      right: {base: 5, lg: 0},
    },
    tabsList: {
      display: {base: 'none', md: 'flex'},
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 10,
      flexDirection: 'row',
      width: 'full',
    },
    mobileSwiper: {
      display: {base: 'block', md: 'none'},
      width: 'full',
      overflow: 'visible',
      sx: {
        '.swiper-slide': {
          width: 'auto',
          display: 'flex',
          justifyContent: 'center',
        },
      },
    },
    tab: {
      display: 'flex',
      pt: 7,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 7,
      width: {base: 'full', md: 'calc(33.333% - 26.666px)'},
      flex: {base: '0 0 auto', md: '0 0 calc(33.333% - 26.666px)'},
      px: 0,
      borderTopStyle: 'solid',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      _hover: {
        borderTopColor: 'white',
      },
    },
    tabContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 5,
      alignSelf: 'stretch',
    },
    tabNumber: {
      alignSelf: 'stretch',
      fontFamily: 'body',
      fontSize: {base: 'lg', lg: '22px'},
      fontWeight: 'normal',
      lineHeight: '120%',
      transition: 'color 0.3s ease',
    },
    tabTitle: {
      alignSelf: 'stretch',
      fontFamily: 'heading',
      fontSize: {base: 'md', lg: '2xl'},
      fontWeight: 'medium',
      lineHeight: '120%',
      letterSpacing: {base: '-0.16px', md: '-0.24px'},
      transition: 'color 0.3s ease',
    },
  },
};

export default VideoCarousel;
